import React from 'react';
import { ShieldCheck, Lock, Database } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-gradient-to-r from-slate-900 to-blue-800 text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <ShieldCheck className="mx-auto mb-4" size={64} />
          <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-lg text-blue-100">Last Updated: February 14, 2026</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pb-8 border-b">
            <div className="text-center">
              <Lock className="mx-auto text-blue-600 mb-2" size={40} />
              <h3 className="font-semibold text-gray-800 mb-1">Secure by Design</h3>
              <p className="text-sm text-gray-600">Encryption in transit and at rest</p>
            </div>
            <div className="text-center">
              <Database className="mx-auto text-green-600 mb-2" size={40} />
              <h3 className="font-semibold text-gray-800 mb-1">Data Control</h3>
              <p className="text-sm text-gray-600">You control your information</p>
            </div>
            <div className="text-center">
              <ShieldCheck className="mx-auto text-purple-600 mb-2" size={40} />
              <h3 className="font-semibold text-gray-800 mb-1">Transparent Use</h3>
              <p className="text-sm text-gray-600">No sale of personal data</p>
            </div>
          </div>

          <section>
            <h2 className="text-2xl font-bold text-gray-800 mb-3">1. Information We Collect</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Account details (name, email, phone, company)</li>
              <li>Profile data (resume, portfolio, skills, certifications)</li>
              <li>Application activity (jobs applied, status updates)</li>
              <li>Usage data (logins, device, and analytics)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-800 mb-3">2. How We Use Your Information</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Match job seekers with employers</li>
              <li>Enable recruitment workflows and communications</li>
              <li>Maintain platform security and performance</li>
              <li>Comply with legal and regulatory requirements</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-800 mb-3">3. Sharing and Disclosure</h2>
            <p className="text-gray-700 leading-relaxed">
              We share candidate data only with employers for roles the candidate has applied to or expressed interest in. 
              We do not sell your personal data. We may share data with service providers for hosting, analytics, and security under strict confidentiality.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-800 mb-3">4. Data Retention</h2>
            <p className="text-gray-700 leading-relaxed">
              We retain your data for as long as your account is active or as necessary to provide services. You may request deletion at any time.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-800 mb-3">5. Your Rights</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Access and correct your personal data</li>
              <li>Request deletion of your account</li>
              <li>Withdraw consent where applicable</li>
            </ul>
          </section>

          <section className="bg-gray-50 border border-gray-200 rounded-lg p-6">
            <h2 className="text-xl font-bold text-gray-800 mb-3">Contact Us</h2>
            <p className="text-gray-700 mb-3">For privacy-related questions, contact us:</p>
            <div className="space-y-1 text-gray-700">
              <p><strong>Talent Link Employment Agency</strong></p>
              <p>Email: <a href="mailto:info@talentlinkemploymentagency.com" className="text-blue-600 hover:underline">info@talentlinkemploymentagency.com</a></p>
              <p>Phone: <a href="tel:+263772155436" className="text-blue-600 hover:underline">+263 77 215 5436</a></p>
              <p>Location: Harare, Zimbabwe</p>
            </div>
          </section>

          <p className="text-center text-sm text-gray-500">
            © 2026 Talent Link Employment Agency. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
